/**
 * Web Vitals Performance Reporting
 *
 * This module provides performance monitoring and reporting functionality
 * using Google's Web Vitals library to track Core Web Vitals metrics.
 *
 * Core Features:
 * - Core Web Vitals performance measurement
 * - Real-time performance data collection
 * - Configurable performance callback system
 * - Browser performance API integration
 * - Performance analytics and reporting
 *
 * Measured Metrics:
 * - CLS (Cumulative Layout Shift) - Visual stability
 * - FID (First Input Delay) - Interactivity responsiveness
 * - FCP (First Contentful Paint) - Loading performance
 * - LCP (Largest Contentful Paint) - Loading speed
 * - TTFB (Time to First Byte) - Server response time
 *
 * Performance Monitoring:
 * - Automatic metric collection and reporting
 * - Real user monitoring (RUM) data
 * - Performance threshold monitoring
 * - User experience quality assessment
 * - Performance regression detection
 *
 * Integration Points:
 * - Google Analytics integration
 * - Custom analytics platforms
 * - Performance monitoring services
 * - Application performance management
 * - Business intelligence systems
 *
 * Usage Pattern:
 * - Call with callback function for metric handling
 * - Automatic collection during user interactions
 * - Performance data sent to analytics systems
 * - Real-time performance monitoring
 * - Performance optimization insights
 *
 * This module enables comprehensive performance monitoring and helps
 * maintain optimal user experience through data-driven insights.
 */
const reportWebVitals = onPerfEntry => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
            getCLS(onPerfEntry);
            getFID(onPerfEntry);
            getFCP(onPerfEntry);
            getLCP(onPerfEntry);
            getTTFB(onPerfEntry);
        });
    }
};
export default reportWebVitals;
